import { navigate } from "gatsby"

export const Redirect = link => {
  if (link) {
    navigate(link)
  }
}

export default Redirect
